import _ from 'lodash';
const formatRanking = (item) => {
    const { value = [], } = item;
    return {
        ...item,
        isLoading: false,
        value,
    };
};
export default function (data) {
    if (Array.isArray(data)) {
        return _.map(data, (item) => {
            return formatRanking(item);
        });
    }
    return formatRanking(data);
}
